function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3,
  d: "M12.072 24.11h1.056c.374-.25 9.069-6.122 9.069-13.271A9.598 9.598 0 008.87 1.753a9.6 9.6 0 00-5.867 9.088c0 7.146 8.694 13.018 9.069 13.268zm.531-20.95a7.677 7.677 0 017.674 7.681c0 5.193-5.854 9.943-7.677 11.3-1.823-1.352-7.677-6.1-7.677-11.3a7.677 7.677 0 017.68-7.68zm5.144 7.5a5.144 5.144 0 10-10.289 0 5.144 5.144 0 0010.289.005v-.004zm-8.368 0a3.224 3.224 0 110 .005v-.004z"
});

var SvgVenues = function SvgVenues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venues.fb1b5b38.svg";
export { ForwardRef as ReactComponent };